import { useCurrencyDisplay } from "@providers/CurrencyDisplayProvider";

export const useCurrencyChanged = (originalCurrency?: string): boolean => {
  const { selectedCurrencyView, globalCurrency } = useCurrencyDisplay();

  const toggleHidden =
    !!originalCurrency &&
    originalCurrency.toUpperCase() === globalCurrency.toUpperCase();

  return !toggleHidden && selectedCurrencyView === "global";
};
